import React from 'react';

const PatientNormothermia = () => {
  return (


<>

<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Patient thermoregulation system</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div className="service-details-area section">
      <div className="container">
        <div className="services-details-img">
          <img src="img/service-details-bg.jpg" alt="Service Details Background" />
          {/* <h2>Our hospital always provide good services</h2> */}
          <p>
          Thermoregulation is the biological mechanism responsible for maintaining a steady internal body temperature.

Hypothalamus is a section of our brain that controls thermoregulation Hypothalamus helps to manage our Body temperature, Blood Pressure, Hunger and Thirst, Sense of fullness when eating, mood, Sleep.

The average person has a baseline temperature between 98°F (37°C) our body has some ﬂexibility with temperature. However, the body temperature above 37 degree centigrade or below 37 degree centigrade temperature can aﬀect your body's ability to function.

The human body maintains a temperature of about 98.6°F (37°C) using various physical processes. These include sweating to lower the body temperature, shivering to raise it if our body temperature falls lower than 35 degree centigrade, We have hypothermia. This condition can lead to cardiac arrest, brain damage, or even death. if our body temperature rises above 104°F (40°C).
          </p>
          <blockquote>
            <i className="icofont-quote-left"></i>
            Heat stroke is considered a medical emergency. If our body temperature rises to high, we can experience brain damage or even death.

Many factors can aﬀect our body's temperature, such as spending time in cold or hot weather.

Our hypothalamus is a section of your brain that controls thermoregulation. When the hypothalamus senses your internal temperature becoming too low or high, it sends signals to our muscles, organs, glands, and nervous system.

They respond in various ways to help return your temperature to its typical levels.

If our internal temperature drops or rises outside of the typical range, our body will take steps to adjust it. This process is known as thermoregulation.

It can help us to avoid or recover from potentially dangerous conditions like hypothermia or Hyperthermia.

If an individual is unable to regulate their temperature, they could overheat, leading to hyperthermia. If the core temperature falls below a safe level, it will cause hypothermia. Both conditions can potentially be life threatening.
          </blockquote>
          <p>
          Forced air patient warming system

The patient warming system is a convective temperature management device that maintains a patient's core body temperature in a hospital or operation theater.<br/><br/>

Before, during, and after the operation,Forced air warming. Air is sucked in from the surroundings and warmed using electric coils. The blower circulates the warm air through a blanket that warms the patient through convection.<br/><br/>

Forced-air warming systems ﬁlter air through HEPA & Plasma ﬁlters and then force the warm air through a disposable blanket, which cover patients
          </p>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="service-details-inner-left">
              <img src="/images/home8.jpg" alt="Service Signup Background" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="service-details-inner-left">
              <img src="/images/ww3.jpg" alt="Service Signup Background" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="service-details-inner-left">
              <img src="/images/home9.jpg" alt="Service Signup Background" />
            </div>
          </div>
      
      
      

          {/* <div className="col-lg-7">
            <div className="service-details-inner">
              <h2>
                We always take care <br />
                our patient
              </h2>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Architecto blanditiis obcaecati veritatis magnam pariatur
                molestiae in maxime. Animi quae vitae in inventore. Totam
                mollitia aspernatur provident veniam aperiam placeat impedit!
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe
                rem natus nobis, dolorum nam excepturi iure autem nemo ducimus
                temporibus facere, est eum voluptatem, culpa optio fugit
                assumenda quod? Praesentium.
              </p>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Id,
                laudantium ullam, iure distinctio officia libero voluptatem
                obcaecati vero deleniti minima nemo itaque alias nisi eveniet
                soluta architecto quae laboriosam unde.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>

</>
  );
};

export default PatientNormothermia;
